<template>
    <template v-for="(item, index) in uploadNoticeList" :key="index">
        <ProgressBox
            :showProgressStep="false"
            :processStatus="item.status"
            @close="closeThisPanner(item)"
            :statusConfig="statusConfig"
        >
            <template v-slot:subtitle >
                <span v-html="statusConfig[item.status].subtitle"> </span>
            </template>
        </ProgressBox>
    </template>
</template>

<script>
import ProgressBox from '@/components/design-system/design-payroll-notice-panel.vue';

export default {
    components: {
        ProgressBox,
    },
    data() {
        return {
            uploadNoticeList: [ 
            ],
            statusConfig: {
                PROCESSING: {
                    heading: 'Upload Time Log Report',
                    closeAction: 'close',
                    subtitle: 'Now uploading time log report...',
                    textWidth: 330,
                },
                FINISHED: {
                    heading: 'Upload Time Log Report Completed',
                    closeAction: 'close',
                    subtitle: 'Time log report has been successfully uploaded.',
                    textWidth: 330,
                },
                FAIL: {
                    heading: 'Upload Time Log Report Failed',
                    closeAction: 'close',
                    subtitle: 'Time log report has been failed. Please try again.',
                    textWidth: 330,
                },
            },

            eventSource : null,
            isConnecting : false,
        };
    },
    methods: {
        getTimeReportUploadPanel(currentStatus){
            if(currentStatus == null || currentStatus == "" || currentStatus == undefined ) return [];
            return [{status : currentStatus}];
        },
        closeThisPanner() {
            const self = this;
            const checkUrl = self.$api('uri', 'get-time-report-panel-delete');
            self.$axios.get(checkUrl)
                .then((res) => {
                    console.log("isCleared" , res.data.data);
                    self.uploadNoticeList = [];
                })
                .catch(err=>{
                    console.error("[error] ", err)
                })
        },
        checkAndConnectSSE() {
            const self = this;
            // ▼ 'this.yourVariableName'을 실제 사용하는 변수명으로 변경하세요.
            if (!window.connectAjaxRunning) {
                // 1. 조건이 true이면, SSE를 연결하고 함수를 종료합니다.
                // (더 이상 5초마다 재시도하지 않음)
                self.connectSSE();
            } else {
                // 2. 조건이 false이면, 5초 후에 이 함수를 다시 실행하여 재검사합니다.
                setTimeout(() => {
                    self.checkAndConnectSSE();
                }, 5000);
            }
        },
        connectSSE() {
            const self = this;

            if( self.eventSource || self.isConnecting ){
                console.warn("[SSE time-report-upload]:Already connected")
                return;
            }


            const url = this.$api('uri', 'get-stream-time-report-upload');
            this.isConnecting = true; 
            try {

                this.eventSource = new EventSource(url, {
                    withCredentials: true,
                    mode: 'cors',
                });

                this.eventSource.addEventListener('initialization', (event) => {
                    self.uploadNoticeList = self.getTimeReportUploadPanel(event?.data);
                });


                this.eventSource.addEventListener('sseSubscribeTimeReportUpdate', (event) => {
                    self.uploadNoticeList = self.getTimeReportUploadPanel(event?.data);     
                });

                // 연결 수립
                this.eventSource.onopen = () => {
                    console.log("[SSE time-report-upload]: Connection opened");
                    this.isConnecting = false; // 연결 완료
                };

                // 에러 처리
                this.eventSource.onerror = (err) => {
                    self.eventSource.close();
                    this.eventSource = null;
                    this.isConnecting = false;
                    setTimeout(self.connectSSE, 500); // 재연결
                };

            }catch(e){
                console.error("[SSE time-report-upload]:Failed to connect:", e);
                this.eventSource = null;
                this.isConnecting = false;
                setTimeout(() => this.connectSSE(), 5000);
            }
            
            
        },
    },
    mounted() {
        const self = this;
        console.error('window.connectAjaxRunning', window.connectAjaxRunning);
        setTimeout(()=>{
            self.checkAndConnectSSE();
        }, 5000);
    },
    beforeUnmount() {
        if (this.eventSource) {
            this.eventSource.close();
            this.eventSource = null;
        }
        this.isConnecting = false;
    },
};
</script>
